import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {ehCelular, EstadoOnboardingPainel, OnboardingPainelService} from '../onboarding-painel.service';
import {ConstantsService} from '../../fidelidade/ConstantsService';

const QRCode = require('qrcode');

/** Loja pronta: o bônus garantido, o link e três jeitos de trazer o primeiro cliente de verdade hoje. */
@Component({
  selector: 'app-tela-pronto',
  templateUrl: './tela-pronto.component.html',
  styleUrls: ['./tela-pronto.component.scss']
})
export class TelaProntoComponent implements OnInit {
  @Input() estado: EstadoOnboardingPainel;
  @Input() empresa: any = {};

  qr = '';
  copiado = '';
  /** No celular a folha de compartilhar leva a mensagem direto para o status ou um grupo do WhatsApp. */
  readonly podeCompartilhar = ehCelular() && typeof navigator !== 'undefined' && !!(navigator as any).share;

  constructor(private onboarding: OnboardingPainelService, private constants: ConstantsService, private router: Router) {}

  ngOnInit(): void {
    if (this.link) QRCode.toDataURL(this.link, {margin: 1, width: 600}).then((url: string) => this.qr = url).catch(() => {});
  }

  get link(): string { return String(this.empresa?.linkLoja || ''); }

  get linkCurto(): string { return this.link.replace(/^https?:\/\//, '').replace(/\/$/, ''); }

  get mensagem(): string {
    return `Agora você pode pedir da ${this.empresa?.nome || 'nossa loja'} pelo nosso cardápio digital!\n` +
      `É só tocar no link, escolher e pedir:\n${this.link}`;
  }

  copie(texto: string, qual: string): void {
    const feito = () => {
      this.copiado = qual;
      setTimeout(() => this.copiado = '', 1800);
      this.onboarding.confirme('link-divulgado').catch(() => {});
    };
    try { navigator.clipboard.writeText(texto).then(feito, feito); } catch (e) { feito(); }
  }

  compartilhe(): void {
    Promise.resolve((navigator as any).share({text: this.mensagem}))
      .then(() => this.onboarding.confirme('link-divulgado').catch(() => {}))
      .catch(() => {});
  }

  imprimaQr(): void {
    if (!this.qr) return;
    const janela = window.open('', '_blank');
    if (!janela) return;
    const nome = String(this.empresa?.nome || '').replace(/</g, '&lt;');
    janela.document.write(`<title>QR ${nome}</title><body style="margin:0;display:grid;place-items:center;min-height:100vh;font-family:sans-serif;text-align:center">
      <div><h2 style="margin:0 0 8px">${nome}</h2><p style="margin:0 0 16px">Aponte a câmera e peça pelo cardápio digital</p>
      <img src="${this.qr}" style="width:320px;height:320px"><p>${this.linkCurto}</p></div>
      <script>setTimeout(function(){window.print()},300)</script></body>`);
    janela.document.close();
    this.onboarding.confirme('link-divulgado').catch(() => {});
  }

  /**
   * Espera a empresa recarregar antes de ir: com o onboarding ainda "ativo" na memória, o Início mandaria o dono de
   * volta para os primeiros passos, e o menu ficaria na fase 1.
   */
  irParaOPainel(): void {
    Promise.resolve(this.constants.recarregueEmpresa()).catch(() => {})
      .finally(() => this.router.navigateByUrl('/admin/index'));
  }
}
